import type { SampleTestOnecDiscrepancy, SampleTestStatus } from '@/api';
import type { BadgeTone } from '@/ui';

/*
 * Подписи плана тестирования образцов. Статусы и тоны - как RESULT_BADGE макета
 * («Проектная таблица»): «Тестируется» - согласование, «Одобрено» - завершено,
 * «Не подошло» - возврат. Подписи итога - решение Игоря (plan/sample-tests,
 * «Решения»).
 */

export const SAMPLE_TEST_STATUSES: Record<
  SampleTestStatus,
  { label: string; tone: BadgeTone }
> = {
  Testing: { label: 'Тестируется', tone: 'approval' },
  Succeeded: { label: 'Одобрено', tone: 'completed' },
  Failed: { label: 'Не подошло', tone: 'returned' },
};

/**
 * Расхождение с отгрузкой в 1С: что там случилось, а тест остался со следами менеджера.
 * Подпись - первая строка подсказки у номера отгрузки, поэтому называет 1С сама.
 */
export const SAMPLE_TEST_DISCREPANCIES: Record<
  SampleTestOnecDiscrepancy,
  string
> = {
  ShipmentNotPosted: 'Отгрузка снята с проведения в 1С',
  ShipmentDeleted: 'Отгрузка удалена в 1С',
  ProductRemoved: 'Товар убран из отгрузки в 1С',
};
